<div class="resources-container">
  <h3>Song Resources</h3>
  <button *ngIf="!viewMode" mat-raised-button color="primary" (click)="addResource()">Add Resource</button>

  <table *ngIf="resources.length > 0">
    <thead>
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th *ngIf="!viewMode">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let resource of resources">
        <td>
          <span *ngIf="resource.isHyperlink">
            <a [href]="resource.path" target="_blank">{{ resource.name }}</a>
          </span>
          <span *ngIf="!resource.isHyperlink" (click)="onResourceClick($event, resource)" style="cursor: pointer; color: green; text-decoration: underline;">
            {{ resource.name }}
          </span>
        </td>
        <td>{{ resource.resourceType }}</td>
        <td *ngIf="!viewMode">
          <button mat-button color="primary" (click)="editResource(resource)">Edit</button>
          <button mat-button color="warn" (click)="deleteResource(resource.id)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>

  <mat-card *ngIf="!viewMode && showResourceForm" class="resource-form" #resourceFormCard>
    <mat-card-title>{{ selectedResource ? 'Edit Resource' : 'Add Resource' }}</mat-card-title>
    <mat-card-content>
      <form [formGroup]="resourceForm" (ngSubmit)="saveResource()">
        <!-- Resource Name and Resource Type on the same row -->
        <div style="display: flex; gap: 16px;">
          <mat-form-field appearance="fill" style="flex: 1;">
            <mat-label>Resource Name</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>

          <mat-form-field appearance="fill" style="flex: 1;">
            <mat-label>Resource Type</mat-label>
            <input matInput formControlName="resourceType">
          </mat-form-field>
        </div>

        <!-- Is Hyperlink -->
        <mat-checkbox formControlName="isHyperlink" (change)="onIsHyperlinkChange()">Is Hyperlink</mat-checkbox>

        <!-- Path -->
        <mat-form-field appearance="fill">
          <mat-label>Path</mat-label>
          <input matInput formControlName="path" [disabled]="!resourceForm.get('isHyperlink')?.value">
        </mat-form-field>

        <!-- Upload File -->
        <div>
          <label for="file-upload">Upload File:</label>
          <input
            id="file-upload"
            type="file"
            (change)="onFileSelected($event)"
            [disabled]="resourceForm.get('isHyperlink')?.value"
          >
          <div *ngIf="currentFile && !selectedFile" style="margin-top: 8px; color: #666; font-size: 0.9em;">
            Current file: <strong>{{ currentFile }}</strong> (Select a new file to replace)
          </div>
          <div *ngIf="selectedFile" style="margin-top: 8px; color: #4caf50; font-size: 0.9em;">
            New file selected: <strong>{{ selectedFile.name }}</strong>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button mat-raised-button color="primary" type="submit">Save</button>
          <button mat-raised-button color="warn" type="button" (click)="closeForm()">Cancel</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>